export const formatDate = (date) => {
  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0") +
    "T" +
    String(date.getHours()).padStart(2, "0") +
    ":" +
    String(date.getMinutes()).padStart(2, "0") +
    ":" +
    String(date.getSeconds()).padStart(2, "0") +
    "." +
    String(date.getMilliseconds()).padStart(3, "0")
  );
};

export const formatDateUTC = (date) =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
    timeZone: "UTC",
  });

export const formatTimeUTC = (date) => {
  let hours = date.getUTCHours();
  let minutes = date.getUTCMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format
  return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
};

export const base64ToBlob = (base64, mimeType) => {
  const byteCharacters = atob(base64.split(",")[1]); // Decode Base64
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i));
  }

  return new Blob([new Uint8Array(byteArrays)], { type: mimeType });
};

export const generateEmailBody = (
  lastName,
  formattedDateUTC,
  formattedStartTimeUTC,
  formattedEndTimeUTC,
  blobToImgApi,
  getUserEmployee
) => `
    <html>
  <body style="font-family: Arial, sans-serif; color: #000;">
    <p>Dear ${lastName},</p>
    <p>Welcome to <strong>LGS Staff Management Services Incorporated</strong>!</p>
    <p>
      My name is ${getUserEmployee?.sex === "Male" ? "Mr." : "Ms."} <strong>${
  getUserEmployee.firstName
}</strong>, 
      HR/Recruitment Officer of LGS Staff Management Services Incorporated. 
      Congratulations and thank you for completing the recruitment process. 
      We are excited to officially begin your onboarding as part of the LGS team. 
      Please see the details of your scheduled onboarding below:
    </p>
    <p><strong>When:</strong> ${formattedDateUTC}</p>
    <p><strong>Time:</strong> ${formattedStartTimeUTC}</p>
    <p><strong>Where:</strong> LGS Centre, <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian corner</a>, Rockefeller St. Brgy. San Isidro, Makati City</p>
    <p><strong>Attire:</strong> Smart Casual</p>
    <p>
      Please bring the following requirements with you:
      <ul>
        <li>2 copies of your updated resume</li>
        <li>Valid government-issued ID</li>
        <li>Black ballpen</li>
        <li>Photocopies of your pre-employment requirements</li>
      </ul>
    </p>
    <p>Below is your QR code for onboarding attendance:</p>
    <img src="${blobToImgApi?.url}" alt="QR Code" width="200" height="200" />
    <p>Should you have any questions, feel free to reach out. We look forward to having you on board!</p>
    <p>Sincerely yours,</p>
    <p>
      <strong>${getUserEmployee?.firstName} ${getUserEmployee?.middleName}. ${
  getUserEmployee?.lastName
}</strong><br>
      Recruitment Officer<br>
      <strong>LGS Staff Management Services Inc.</strong><br>
      <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian St.</a>, Brgy. San Isidro, Makati City, 1234 Philippines
    </p>
    <div style="display:flex">
      <img src="https://dev.lgs.mweeb.com/LGS_email_left.png" alt="LGS Logo Left" width="100" height="100" style="display:block;object-fit:contain;">
      <img src="https://dev.lgs.mweeb.com/LGS_email_right.jpg" alt="LGS Logo Right" width="100" height="100" style="display:block;object-fit:contain;">
    </div>
  </body>
</html>

  `;
